import { axiosRef } from '../../api';
import { UsersDropdownOption } from '../interfaces';

interface UsersDropdownQueryPayload {
  search?: string;
  isPagination?: string;
}

export default async function getUsersDropdown(
  payload: UsersDropdownQueryPayload,
  isAdmin: boolean,
  setLoading: (loading: boolean) => void,
) {
  setLoading(true);

  let url = `${isAdmin ? '/admin' : ''}/users_dropdown`;
  if (payload?.search) {
    url += `search=${payload.search}&`;
  }
  if (payload?.isPagination) {
    url += `is_pagination=${payload.isPagination}`;
  }

  try {
    const response = await axiosRef.get(url);
    setLoading(false);

    if (!response?.data?.is_error) {
      return response.data.content.data.map((option: UsersDropdownOption) => ({
        id: option.id,
        label: `${option.first_name || '-'} ${option.last_name || '-'}`,
        value: option.username,
      }));
    }
    return [];
  } catch (error) {
    setLoading(false);
    return [];
  }
}
